import ApiHelper from "../../../util/api/ApiHelper";
import { APPLICATION_SERVER } from "../../../constants";
import AuthRepository from "../../../domain/repositories/auth/AuthRepository";
import RequestOptions from "../../../util/api/RequestOptions";
import AdminRepository from "../../../domain/repositories/admin/AdminRepository";
import User from "../../../domain/models/admin/User";
import UserRegResponse from "../../../domain/models/admin/UserRegResponse";

export default class AdminRepositoryImpl implements AdminRepository {
  private authRepository: AuthRepository;

  public constructor(authRepository: AuthRepository) {
    this.authRepository = authRepository;
  }

  public onSearchForUser = async (email: string): Promise<User> => {
    const requestOptions: RequestOptions = new RequestOptions();

    requestOptions.addHeader("Authorization", `Bearer ${this.authRepository.getAccessToken()}`);
    requestOptions.setBody(JSON.stringify({ email }));

    return ApiHelper.fetchPostJson<User>(`${APPLICATION_SERVER}/api/admin/find-user`, requestOptions);
  };

  public onAddUser = (username: string, email: string, password: string): Promise<UserRegResponse> => {
    const requestOptions: RequestOptions = new RequestOptions();

    requestOptions.addHeader("Authorization", `Bearer ${this.authRepository.getAccessToken()}`);
    requestOptions.setBody(JSON.stringify({ email, password, username }));

    return ApiHelper.fetchPostJson<UserRegResponse>(`${APPLICATION_SERVER}/api/admin/add-user`, requestOptions);
  };

  public onDeleteUser = (email: string): Promise<unknown> => {
    const requestOptions: RequestOptions = new RequestOptions();

    requestOptions.addHeader("Authorization", `Bearer ${this.authRepository.getAccessToken()}`);
    requestOptions.setBody(JSON.stringify({ email }));

    return ApiHelper.fetchPostJson<User>(`${APPLICATION_SERVER}/api/admin/delete-user`, requestOptions);
  };
}
